// TabPanel — preserves in-flight state across tab switches.
//
// Previously the matter-detail page used the pattern
//   `activeTab === "documents" && <Component />`
// which unmounts the component every time the user clicks away. That
// destroys state — a half-loaded extraction, a running PACER search,
// a partially-filled form, all gone on tab switch.
//
// TabPanel wraps the children in a div that toggles `display: none`
// when the tab isn't active. The components stay mounted (state +
// effects preserved) but are visually hidden. To keep first-load
// fast, panels only mount on FIRST activation (everActive guard) —
// before the user has visited a tab, its children don't render at
// all. After that, switching away just hides them; switching back
// reveals the same instance with state intact.
//
// `ids` can be a single string or an array of strings (a panel can
// be visible on multiple tabs — e.g., MatterActivityCard shows on
// both Activity and Overview).

import React, { useState, useEffect } from "react";

export function TabPanel({ activeTab, ids, children }) {
  const visibleIds = Array.isArray(ids) ? ids : [ids];
  const isActive = visibleIds.includes(activeTab);
  const [everActive, setEverActive] = useState(isActive);
  useEffect(() => {
    if (isActive && !everActive) setEverActive(true);
  }, [isActive, everActive]);
  if (!everActive) return null;
  return React.createElement("div", {
    style: { display: isActive ? "block" : "none" },
  }, children);
}
